import { ActionResponseModalComponent } from './private/ACTIONS/action-response-modal/action-response-modal.component';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { HomeCourrierComponent } from './private/DASHBOARD/home-courrier/home-courrier.component';
import { HomeCourrierChildComponent } from './private/DASHBOARD/home-courrier-child/home-courrier-child.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SuperListSimpleECourrierComponent } from './components/super-list-simple/super-list-simple.component';
import { HomeActionComponent } from './private/ACTIONS/home-action/home-action.component';
import { AssistanceComponent } from './private/assistance/assistance.component';
import { ContactsComponent } from './private/CONTACT/contacts/contacts.component';
import { ContactEditionComponent } from './private/CONTACT/contact-edition/contact-edition.component';
import { NgbAccordionModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { PrivateComponent } from './private/private/private.component';
import { PublicComponent } from './public/public/public.component';
import { HomeComponent } from './public/public/home/home.component';
import { HomePrivateComponent } from './private/home/home.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { SignatureCallbackComponent } from './public/public/signature-callback/signature-callback.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ActionCreateModalComponent } from './private/ACTIONS/action-create-modal/action-create-modal.component';
import { DocumentEditorContainerModule, DocumentEditorModule } from '@syncfusion/ej2-angular-documenteditor';
import { DocumentEditorComponent } from './private/COURRIER-S/document-editor/document-editor.component';
import { PipesModule } from './_pipes/@pipes.module';

import { CourrierCreateTemplateChoiceComponent } from './private/COURRIER-S/courrier-create-template-choice/courrier-create-template-choice.component';
import { HttpErrorInterceptor } from './providers/http-error-interceptor';
import { HttpErrorModalComponent } from './components/modals/http-error-modal/http-error-modal.component';
import { GlobalModalComponent } from './components/modals/global-modal/global-modal.component';
import { ToastrModule } from 'ngx-toastr';

import { MglTimelineModule } from 'angular-mgl-timeline';
import { CourrierFileViewerComponent } from './private/COURRIER-E/courrier-file-viewer/courrier-file-viewer.component';
import { CourrierCreateAddFilesComponent } from './private/COURRIER-S/courrier-create-add-files/courrier-create-add-files.component';
import { CourrierFicheFormComponent } from './private/COURRIER-E/courrier-fiche-form/courrier-fiche-form.component';
import { CourrierCreateComponent } from './private/COURRIER-S/courrier-create/courrier-create.component';
import { RecipientModalComponent } from './private/COURRIER-S/recipient-modal/recipient-modal.component';
import { CourrierEditionFormComponent } from './private/COURRIER-S/courrier-edition-form/courrier-edition-form.component';
import { HomeCourrierTreeComponent } from './private/DASHBOARD/home-courrier-tree/home-courrier-tree.component';
import { HomeCourrierKanbanComponent } from './private/DASHBOARD/home-courrier-kanban/home-courrier-kanban.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CourrierFicheHistoryComponent } from './private/COURRIER-E/courrier-fiche-history/courrier-fiche-history.component';
import { ValidatorsComponent } from './validators/validators.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ContactListComponent } from './private/contact-list/contact-list.component';
import { ContactCompanyLinkedComponent } from './private/CONTACT/contact-company-linked/contact-company-linked.component';
import { Page401Component } from './public/page401/page401.component';
import { ContactPictureComponent } from './private/CONTACT/contact-picture/contact-picture.component';
import { ContactDetailsComponent } from './private/CONTACT/contact-details/contact-details.component';
import { ConfirmDeactivateGuard } from './guards/confirm-deactivate.guard';
import { CourrierDetailsComponent } from './private/COURRIER-E/courrier-details/courrier-details.component';
import { ContactNewComponent } from './private/CONTACT/contact-new/contact-new.component';
import { CModeChoiceModalComponent } from './components/modals/c-mode-choice-modal/c-mode-choice-modal.component';
import { FileChoiceModalComponent } from './components/modals/file-choice-modal/file-choice-modal.component';
import { CourrierCreateModalComponent } from './private/COURRIER-S/courrier-create-modal/courrier-create-modal.component';
import { CourrierCreateRecipientsComponent } from './private/COURRIER-S/courrier-create-recipients/courrier-create-recipients.component';
import { TemplateViewModalComponent } from './components/modals/template-view-modal/template-view-modal.component';
import { MailTypeModalComponent } from './components/modals/mail-type-modal/mail-type-modal.component';
import { ContactMembersLinkedComponent } from './private/CONTACT/contact-members-linked/contact-members-linked.component';
import { ContactPreviewModalComponent } from './private/CONTACT/contact-preview-modal/contact-preview-modal.component';
import { ClassementModalComponent } from './components/modals/classement-modal/classement-modal.component';
import { CourrierLienComponent } from './private/COURRIER-S/courrier-lien/courrier-lien.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { HomeCourrierTreeTblComponent } from './private/DASHBOARD/home-courrier-tree-tbl/home-courrier-tree-tbl.component';
import { CourrierForTabsComponent } from './private/COURRIER-E/courrier-for-tabs/courrier-for-tabs.component';
import { DocumentSaveModalComponent } from './components/modals/document-save-modal/document-save-modal.component';
import { CourrierDeactivateGuard } from './guards/courrier-deactivate.guard';
import { GuardConfirmModalComponent } from './components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { ConfirmLinkedGuard } from './guards/confirm-linked.guard';
import { EmailFileSelectModalComponent } from './private/COURRIER-S/email-file-select-modal/email-file-select-modal.component';
import { DocumentEditorByFileIdComponent } from './private/COURRIER-S/document-editor-by-file-id/document-editor-by-file-id.component';
import { DocumentToValidateComponent } from './private/DASHBOARD/home-courrier/document-to-validate/document-to-validate.component';
import { DocumentToSignComponent } from './private/DASHBOARD/home-courrier/document-to-sign/document-to-sign.component';
import { DialogReleasesNotesComponent } from './private/dialog-releases-notes/dialog-releases-notes.component';
import { PrendreEnChargeModalComponent } from './private/COURRIER-E/prendre-en-charge-modal/prendre-en-charge-modal.component';
import { SuperBoxListCustomComponent } from './private/DASHBOARD/super-box-list/super-box-list.component';
import { ProfilComponent } from './private/profil/profil.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ArchivageModalsComponent } from './components/modals/archivage-modals/archivage-modals.component';
import { AngularSplitModule } from 'angular-split';
import { PrimengModule } from './@primeng.module';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CourrierExchangeComponent } from './private/COURRIER-E/courrier-exchange/courrier-exchange.component';
import { DocumentEditorSimpleComponent } from './private/document-editor-simple/document-editor-simple.component';
import { ReportingComponent } from './private/reporting/reporting.component';
import { DuplicateModalsComponent } from './components/modals/duplicate-modals/duplicate-modals.component';
import { LockedCourriersComponent } from './private/locked-courriers/locked-courriers.component';
import { NoInfoComponent } from './components/no-info/no-info.component';
import { CreationCourrierComponent } from './components/creation-courrier/creation-courrier.component';
import { ChooseSourceTypeModalComponent } from './components/modals/choose-source-type-modal/choose-source-type-modal.component';
import { QrCodeModalComponent } from './components/modals/qr-code-modal/qr-code-modal.component';
import { FileviewerComponent } from './private/fileviewer/fileviewer.component';
import { ContactNewSimpleComponent } from './private/CONTACT/contact-new-simple/contact-new-simple.component';
import { PersonalParamsComponent } from './private/profil/personal-params/personal-params.component';
import { SuperListNewVisualComponent } from './private/DASHBOARD/home-courrier-child/super-list/super-list.component';
import { AdvSearchComponent } from './private/adv-search/adv-search.component';
import { ComplementDataFormComponent } from './components/complement-data-form/complement-data-form.component';
import { DisplayFiltersComponent } from './private/DASHBOARD/home-courrier-child/display-filters/display-filters.component';
import { CourrierDetailsGeneralInfosComponent } from './private/COURRIER-E/courrier-details-general-infos/courrier-details-general-infos.component';
import { SearchRecipientComponent } from './components/modals/search-recipient/search-recipient.component';
import { CreateEditBinderModalComponent } from './private/classements/management-folders/create-edit-binder-modal/create-edit-binder-modal.component';
import { CreateEditPlasticLinerComponent } from './private/classements/management-folders/create-edit-plastic-liner/create-edit-plastic-liner.component';
import { CreateNewTagComponent } from './components/modals/create-new-tag/create-new-tag.component';
import { MassAttachScansComponent } from './components/iscanV2/mass-attach-scans/mass-attach-scans.component';

import { RichEditReaderComponent } from './components/utils/reader/reader.component';
import { ModalAssignPastellCircuitComponent } from './components/modals/modal-assign-pastell-circuit/modal-assign-pastell-circuit.component';
import { AssignAttachmentsComponent } from './private/COURRIER-E/assign-circuit-modal/assign-attachments-modal.component';
import { HomeIscanComponent } from './components/iscanV2/home-iscan/home-iscan.component';
import { DetailsScanComponent } from './components/iscanV2/details-scan/details-scan.component';
import { SeparatorPageComponent } from './components/iscanV2/separator-page/separator-page.component';
import { QRCodeModule } from 'angularx-qrcode';
import { SimpleMailCreationModalComponent } from './components/iscanV2/simple-mail-creation-modal/simple-mail-creation-modal.component';
import { AttachScanToExistingMailComponent } from './components/iscanV2/attach-scan-to-existing-mail/attach-scan-to-existing-mail.component';
import { MassEncodeScansComponent } from './components/iscanV2/mass-encode-scans/mass-encode-scans.component';
import { ConfigService } from './shared/services/config.service';
import { ImageCropperModule } from 'ngx-image-cropper';

import { MSAL_INSTANCE, MsalBroadcastService, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { MSALInstanceFactory } from './private/COURRIER-E/courrier-365/msal/module-config';

import { environment } from 'src/environments/environment';

import { SharedModule } from './shared/shared.module';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { ITableModule } from '@devinforius/i-table';
import { INavigationModule } from '@devinforius/i-navigation';
import { IAccordionModule } from '@devinforius/i-accordion';
import { IDxEditorModule } from '@devinforius/i-dx-editor';
import { IViewerModule } from '@devinforius/i-viewer';
import { CircularMenuComponent } from './private/DASHBOARD/circular-menu/circular-menu.component';
import { NotificationsComponent } from './private/profil/notifications/notifications.component';
import { SignatureComponent } from './private/profil/signature/signature.component';
import { FormErrorComponent } from './shared/components/form-error/form-error.component';
import { CheckableListComponent } from './shared/components/checkable-list/checkable-list.component';
import { ConfigSSO, HttpTokenInterceptor, SessionRestoreService, ssoInitializer, SsoModule, SsoService } from '@devinforius/i-sso';
export function appInit(configService: ConfigService) {
  return () => {
    configService.load();
  };
}

const authCodeFlowConfig: ConfigSSO = {
  issuer: environment['issuer'],
  redirectUri: environment['redirectUri'],
  clientId: environment['clientId'],
  scope: environment['scope'],
  debug: false,
  getJwks: true,
  getUserInfo: true,
  enableCheckSession: false,
};

@NgModule({
  declarations: [
    AppComponent,
    HomeCourrierComponent,
    HomeCourrierChildComponent,
    CourrierCreateComponent,
    SuperListSimpleECourrierComponent,
    HomeActionComponent,
    ContactsComponent,
    AssistanceComponent,
    ContactEditionComponent,
    PrivateComponent,
    PublicComponent,
    HomeComponent,
    HomePrivateComponent,
    SignatureCallbackComponent,
    ActionCreateModalComponent,
    DocumentEditorComponent,
    RecipientModalComponent,
    CModeChoiceModalComponent,
    CourrierCreateTemplateChoiceComponent,
    HttpErrorModalComponent,
    GlobalModalComponent,
    CourrierEditionFormComponent,
    CourrierFicheFormComponent,
    CourrierCreateAddFilesComponent,
    CourrierFileViewerComponent,
    CircularMenuComponent,
    HomeCourrierTreeComponent,
    HomeCourrierKanbanComponent,
    CourrierFicheHistoryComponent,
    ValidatorsComponent,
    ContactListComponent,
    ContactCompanyLinkedComponent,
    Page401Component,
    ContactPictureComponent,
    ContactDetailsComponent,
    CourrierDetailsComponent,
    ContactNewComponent,
    FileChoiceModalComponent,
    CourrierCreateModalComponent,
    CourrierCreateRecipientsComponent,
    TemplateViewModalComponent,
    MailTypeModalComponent,
    ContactMembersLinkedComponent,
    ContactPreviewModalComponent,
    ClassementModalComponent,
    CourrierLienComponent,
    HomeCourrierTreeTblComponent,
    CourrierForTabsComponent,
    DocumentSaveModalComponent,
    GuardConfirmModalComponent,
    RichEditReaderComponent,
    ActionResponseModalComponent,
    EmailFileSelectModalComponent,
    DocumentEditorByFileIdComponent,
    DocumentToValidateComponent,
    DocumentToSignComponent,
    DialogReleasesNotesComponent,
    PrendreEnChargeModalComponent,
    SuperBoxListCustomComponent,
    ProfilComponent,
    ArchivageModalsComponent,
    ChooseSourceTypeModalComponent,
    CourrierExchangeComponent,
    AssignAttachmentsComponent,
    DocumentEditorSimpleComponent,
    ReportingComponent,
    DuplicateModalsComponent,
    LockedCourriersComponent,
    NoInfoComponent,
    CreationCourrierComponent,
    QrCodeModalComponent,
    FileviewerComponent,
    ContactNewSimpleComponent,
    PersonalParamsComponent,
    SuperListNewVisualComponent,
    AdvSearchComponent,
    ComplementDataFormComponent,
    DisplayFiltersComponent,
    CourrierDetailsGeneralInfosComponent,
    SearchRecipientComponent,
    CreateEditBinderModalComponent,
    CreateEditPlasticLinerComponent,
    CreateNewTagComponent,
    ModalAssignPastellCircuitComponent,
    DetailsScanComponent,
    HomeIscanComponent,
    SeparatorPageComponent,
    SimpleMailCreationModalComponent,
    AttachScanToExistingMailComponent,
    MassEncodeScansComponent,
    MassAttachScansComponent,
    NotificationsComponent,
    SignatureComponent,
    FormErrorComponent,
    CheckableListComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    PrimengModule,
    NgbDropdownModule,
    NgbAccordionModule,
    NgxDocViewerModule,
    NgxSpinnerModule,
    NgbModalModule,
    PipesModule,
    DocumentEditorContainerModule,
    DocumentEditorModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    MglTimelineModule,
    DragDropModule,
    ScrollingModule,
    SlickCarouselModule,
    NgxExtendedPdfViewerModule,
    AngularSplitModule,
    QRCodeModule,
    ImageCropperModule,
    SharedModule,
    IEssentialsModule,
    ITableModule,
    INavigationModule,
    IAccordionModule,
    IDxEditorModule,
    IViewerModule,
    SsoModule.forRoot(authCodeFlowConfig, environment)
  ],
  exports: [FormsModule, ReactiveFormsModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [ConfigService],
    },
    ConfigService,
    ConfirmDeactivateGuard,
    ConfirmLinkedGuard,
    CourrierDeactivateGuard,
    ConfirmationService,
    DialogService,
    Title,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },

    // ✅ Un seul provideHttpClient qui combine les deux
    provideHttpClient(
      withInterceptors([HttpTokenInterceptor]),
      withInterceptorsFromDi()
    ),

    {
      provide: APP_INITIALIZER,
      useFactory: ssoInitializer,
      deps: [SsoService, SessionRestoreService],
      multi: true,
    },
    // MSAL management
    MsalService,
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {
  constructor() {
    Object.assign(this, environment);
  }
}
